<template>
  <v-bottom-sheet
    v-model="open"
    hide-overlay
  >
    <v-sheet
      class="text-center d-flex align-center justify-center"
      :color="color"
      :height="50"
      dark
      tile
    >
      <span class="mr-1">{{ message }}</span>
      <v-icon>mdi-alert-circle</v-icon>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import { EventBus } from '@/utils/EventBus';

export default defineComponent({
  name: 'MessageBottomSheet',

  setup(props, context) {
    let config = reactive({
      open: false,
      color: 'info',
      message: 'Hello'
    });
    watch(() => config.open, (open, prevOpen) => {
      if (open) {
        setTimeout(() => {
          config.open = false;
        }, 4000);
      }
    });

    /**
     * Handler for open sheet event
     * @param {object} params
     * @param {boolean} params.open
     * @param {string} params.color
     * @param {string} params.message
     * */
    const openSheetHandler = (params) => {
      config = Object.assign(config, params);
    };

    /**
     * Handler for mounted event
     * */
    const onMountedHandler = () => {
      EventBus.$on('openSheet', openSheetHandler);
    };

    /**
     * Handler for before unmount event
     * */
    const onBeforeUnmountEventHandler = () => {
      EventBus.$off('openSheet', openSheetHandler);
    };


    onMounted(onMountedHandler);
    onBeforeUnmount(onBeforeUnmountEventHandler);

    return {
      ...toRefs(config)
    };
  }
});
</script>
